
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$loading-indicator.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$loading-indicator.js';
export default __default__;
